import * as types from './reportActionTypes';

export default (state = false, action) => {
    switch(action.type) {
        case types.LOAD_REPORTS_FAILED:
            return true;
        case types.LOAD_REPORTS_SUCCESS:
            return false;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reports/reportHasErrors.js